export default __webpack_public_path__ + "src/images/btn_refresh-fc5681.png";